import React, { useState } from "react";
import { ROUTES } from "./constants";
import AppointmentManagement from "./AppointmentManagement";

export default function Index() {
  const [page, setPage] = useState(ROUTES.DETAILS);

  switch (page) {
    case ROUTES.DETAILS:
      return <AppointmentManagement setPage={setPage} />;

    default:
      return <AppointmentManagement setPage={setPage} />;
  }
}
